import { useEffect,  useRef } from "react";
import { Outlet } from 'react-router-dom';
import { Helmet, HelmetProvider  } from "react-helmet-async";

let scripts = [
  '/plugins/jquery/jquery.min.js',
  '/plugins/bootstrap/js/bootstrap.bundle.min.js',
  '/plugins/adminlte/adminlte.js'
];

const AnonymousLayout = () => {



  const initialized = useRef(false);

  useEffect(() => {
    // 👇 add class to body element
    document.body.classList.add('login-page');
    if (!initialized.current){
      initialized.current = true;
      scripts.forEach(function(url) {
        let script = document.createElement('script');
        script.src = url;
        script.async = false;
        document.body.appendChild(script);
      });
  }
    
  }, []);

    return (
      <>
      <HelmetProvider>
        <Helmet>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback" />
          {/* Font Awesome */}
          <link rel="stylesheet" href="/plugins/fontawesome-free/css/all.min.css" />
          {/* Ionicons */}
          <link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          {/* Tempusdominus Bootstrap 4 */}
          {/* iCheck */}
          <link rel="stylesheet" href="/plugins/icheck-bootstrap/icheck-bootstrap.min.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="/plugins/adminlte/adminlte.min.css" />    

      </Helmet>
    
       
        <Outlet />

      
      
    </HelmetProvider>
    </>
    )
  }
  
  export default AnonymousLayout;